import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Select.scss';
import classNames from 'classnames';

export default class Select extends Component {
    static propTypes = {
        children: PropTypes.node,
        small: PropTypes.bool,
        className: PropTypes.string,
    }

    render() {
        const { small, className, ...props } = this.props;
        return (
            <div className={classNames(className, styles.container, small ? styles.small : null)}>
                <select className={styles.select} {...props}>
                    {this.props.children}
                </select>
            </div>
        );
    }
}
